module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Button', {
    attrs: {
      "icon": _vm.currentIcon,
      "color": _vm.color,
      "outline": _vm.isChecked,
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        _vm.switchState()
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d19f1dd"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/CheckboxButton/checkbox-button.vue.html
// module id = kzwW
// module chunks = 2